import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { forgotPasswordApi } from "@/utils/apis/auth-service";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useForgotPasswordInsertCode = () => {
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent()
    const [isLoading, setIsLoading] = useState(false)
    const location = useLocation();
    const email = location.state?.email as string;
    const onBackButtonClick = async () => {
        navigate("/forgot-password")
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "back_button",
        });
    }

    const handleResendCode = async () => {
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "resend_code", email },
        });
        forgotPasswordApi(
            email,
            async () => {
                await sendEvent({
                    event: EventType.CHANGE_PASSWORD_RESEND_CODE_SUCCESS,
                    sub_category: "change_password",
                    event_metadata: { email },
                });
                navigate("/forgot-password-insert-code", { state: { email } })
            },
            async (error) => {
                await sendEvent({
                    event: EventType.CHANGE_PASSWORD_RESEND_CODE_FAILED,
                    sub_category: "change_password",
                    event_metadata: { email, error },
                });
            }
        )
    }

    const handleInputSubmit = async (inputData: { [key: string]: string }) => {
        const code = inputData.code
        setIsLoading(true)
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "submit_button",
            event_metadata: { action: "submit_code", email, code },
        });
        setTimeout(() => {
            setIsLoading(false)
            navigate("/new-password", { state: { email, code } })
        }, 1000)
    }

    return {
        onBackButtonClick,
        handleResendCode,
        handleInputSubmit,
        isLoading,
    }
}